module.exports = __webpack_public_path__ + "static/rei-8efca172d2300cfa36a6fa7aa51b8607.png";